<template>
  <div
    :class="[$style.bg, { [$style.bgClosing]: isClosing }]"
    @click.self="startClose"
  >
    <div
      :class="[
        $style.panel,
        { [$style.closing]: isClosing },
        { [$style.indent]: isMobile },
      ]"
    >
      <div :class="$style.contentScroll">
        <div v-if="showCategoryFilter" :class="$style.section">
          <div :class="$style.sectionHeader">
            <span :class="$style.sectionTitle">ПОЛ</span>
          </div>
          <div :class="$style.brandList">
            <div
              v-for="opt in categoryOptions"
              :key="opt.value"
              :class="$style.brandRow"
              @click="toggleCategory(opt.value)"
            >
              <span>{{ opt.label }}</span>
              <div
                :class="[
                  $style.circle,
                  {
                    [$style.activeCircle]: (
                      localFilters.category || []
                    ).includes(opt.value),
                  },
                ]"
              >
                <img
                  v-if="(localFilters.category || []).includes(opt.value)"
                  src="@/assets/img/market/check.svg"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>

        <!-- BRAND -->
        <div v-if="showBrandFilters" :class="$style.section">
          <div :class="$style.sectionHeader">
            <span :class="$style.sectionTitle">БРЕНД</span>
            <button :class="$style.sectionAction" @click="openBrandsSection">
              ВСЕ
              <svg
                width="9"
                height="12"
                viewBox="0 0 9 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.27166 5.93359C8.27166 6.02018 8.25346 6.10221 8.21696 6.17969C8.18506 6.2526 8.13726 6.32096 8.07346 6.38477L2.65936 11.6826C2.53626 11.8057 2.38596 11.8672 2.20816 11.8672C2.09426 11.8672 1.98946 11.8398 1.89376 11.7852C1.79806 11.7305 1.72286 11.6553 1.66816 11.5596C1.61346 11.4684 1.58606 11.3636 1.58606 11.2451C1.58606 11.0765 1.64536 10.9284 1.76386 10.8008L6.74036 5.93359L1.76386 1.06641C1.64536 0.938802 1.58606 0.79069 1.58606 0.62207C1.58606 0.503581 1.61346 0.398763 1.66816 0.307617C1.72286 0.211914 1.79806 0.136719 1.89376 0.0820312C1.98946 0.0273438 2.09426 0 2.20816 0C2.38596 0 2.53626 0.0592448 2.65936 0.177734L8.07346 5.48242C8.13726 5.54622 8.18506 5.61686 8.21696 5.69434C8.25346 5.76725 8.27166 5.84701 8.27166 5.93359Z"
                  fill="#EC6608"
                />
              </svg>
            </button>
          </div>

          <div :class="$style.brandList">
            <!-- КНОПКА "Выбрать все" -->
            <div :class="$style.brandAllRow" @click="selectAllBrands">
              <span :class="$style.brandAllText">Выбрать все</span>
            </div>

            <!-- Список брендов -->
            <div
              v-for="b in brands"
              :key="b"
              :class="$style.brandRow"
              @click="toggleBrand(b)"
            >
              <span>{{ b }}</span>

              <div
                :class="[
                  $style.circle,
                  { [$style.activeCircle]: localFilters.brand.includes(b) },
                ]"
              >
                <img
                  v-if="localFilters.brand.includes(b)"
                  src="@/assets/img/market/check.svg"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>

        <!-- COLOR -->
        <div :class="$style.section">
          <div :class="$style.sectionHeader">
            <span :class="$style.sectionTitle">ЦВЕТ</span>
          </div>

          <div :class="$style.colorRow">
            <div
              v-for="c in colors"
              :key="c"
              :style="{ background: colorMap[c] }"
              :class="[
                $style.colorDot,
                { [$style.colorActive]: localFilters.color === c },
                {
                  [$style.colorLight]:
                    localFilters.color === c && lightColors.includes(c),
                },
              ]"
              @click="toggleColor(c)"
            >
              <div v-if="localFilters.color === c" :class="$style.check">
                <img src="@/assets/img/market/check.svg" alt="" />
              </div>
            </div>
          </div>
        </div>

        <!-- SIZE -->
        <div :class="$style.section">
          <div :class="$style.sectionHeader">
            <span :class="$style.sectionTitle">РАЗМЕР</span>
          </div>

          <div :class="$style.sizeTabs">
            <button
              v-for="t in sizeTypeOptions"
              :key="t.value"
              :class="[
                $style.sizeTab,
                localFilters.size_type === t.value && $style.sizeTabActive,
              ]"
              @click="setSizeType(t.value)"
            >
              {{ t.label }}
            </button>
          </div>

          <DragScroll :className="$style.sizeScrollArea" :interactive="true">
            <button
              v-for="size in sizeOptions"
              :key="String(size)"
              :class="[
                $style.sizeCell,
                isSameSize(localFilters.size, size) && $style.sizeCellSelected,
              ]"
              @click="toggleSize(size)"
            >
              {{ formatSizeValue(size) }}
            </button>
          </DragScroll>
        </div>

        <!-- CUSTOM -->
        <div :class="$style.section">
          <div :class="$style.sectionHeader">
            <span :class="$style.sectionTitle">КАСТОМНЫЕ</span>
          </div>

          <div :class="$style.sizeRow">
            <button
              :class="[
                $style.sizeBtn,
                { [$style.activeSize]: localFilters.custom === true },
              ]"
              @click="
                localFilters.custom = localFilters.custom === true ? null : true
              "
            >
              Да
            </button>
            <button
              :class="[
                $style.sizeBtn,
                { [$style.activeSize]: localFilters.custom === false },
              ]"
              @click="
                localFilters.custom =
                  localFilters.custom === false ? null : false
              "
            >
              Нет
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Buttons -->
    <div :class="[$style.bottomBar, { [$style.indent]: isMobile }]">
      <button :class="$style.clearBtn" @click="reset">Очистить</button>
      <button :class="$style.applyBtn" @click="apply">Применить</button>
    </div>
  </div>
</template>

<script>
import { SIZE_CHART, convertSize } from "@/utils/sizeChart.js"
import DragScroll from "@/components/DragScroll.vue"

export default {
  name: "FiltersModal",
  components: { DragScroll },

  emits: ["apply", "close", "open-brands"],

  props: {
    filters: Object,
    useGlobalBackHandler: {
      type: Boolean,
      default: false,
    },
    showBrandFilters: {
      type: Boolean,
      default: true,
    },
    showCategoryFilter: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      localFilters: {
        brand: [],
        color: null,
        size: null,
        size_type: "EU",
        custom: null,
        category: [],
        ...(JSON.parse(JSON.stringify(this.filters)) || {}),
      },
      categoryOptions: [
        { value: "MALE", label: "Мужские" },
        { value: "FEMALE", label: "Женские" },
        { value: "UNISEX", label: "Унисекс" },
      ],

      brands: [
        "Nike",
        "Jordan",
        "Adidas",
        "Adidas Originals",
        "Yeezy",
        "New Balance",
        "Reebok",
        "Puma",
        "ASICS",
        "Vans",
        "Balenciaga",
        "Premiata",
        "Saucony",
        "Converse",
        "Supreme",
        "Bape",
        "Chrome Hearts",
        "Solomon",
        "Off White",
        "Kith",
      ],
      colors: [
        "beige",
        "black",
        "blue",
        "brown",
        "gray",
        "green",
        "khaki",
        "lightblue",
        "multicolour",
        "orange",
        "pink",
        "purple",
        "red",
        "white",
        "yellow",
      ],
      colorMap: {
        beige: "#F5F5DC",
        black: "#000000",
        blue: "#0000FF",
        brown: "#A52A2A",
        gray: "#808080",
        green: "#008000",
        khaki: "#C3B091",
        lightblue: "#ADD8E6",
        multicolour: "#FF00FF",
        orange: "#FFA500",
        pink: "#FFC0CB",
        purple: "#800080",
        red: "#FF0000",
        white: "#FFFFFF",
        yellow: "#FFFF00",
      },
      isClosing: false,
      backBtn: null,

      isMobile: false,
    }
  },
  computed: {
    lightColors() {
      return ["white", "beige", "lightblue", "yellow", "pink"]
    },
    sizeTypeOptions() {
      return [
        { value: "EU", label: "EU" },
        { value: "RU", label: "RU" },
        { value: "US", label: "US" },
        { value: "UK", label: "UK" },
        { value: "CM", label: "CM" },
      ]
    },
    sizeOptions() {
      const type = String(this.localFilters.size_type || "EU").toUpperCase()
      const key = type === "CM" ? "cm" : type.toLowerCase()

      const values = (SIZE_CHART || [])
        .map((row) => row?.[key])
        .filter((v) => v !== null && v !== undefined)

      const seen = new Set()
      const unique = []
      values.forEach((v) => {
        const k = String(v)
        if (seen.has(k)) return
        seen.add(k)
        unique.push(v)
      })

      const numeric = unique
        .map((v) => ({ raw: v, n: this.parseNumeric(v) }))
        .filter((x) => x.n !== null)
        .sort((a, b) => a.n - b.n)
        .map((x) => x.raw)

      return numeric.length ? numeric : unique
    },
  },
  mounted() {
    // Устанавливаем состояние открытия фильтров в store
    this.$store.commit("setFiltersModalOpen", true)

    if (!this.useGlobalBackHandler && window.Telegram?.WebApp?.BackButton) {
      this.backBtn = window.Telegram.WebApp.BackButton
      this.backBtn.show()
      this.backBtn.onClick(this.startClose)
    }

    if (window.Telegram?.WebApp) {
      const tg = window.Telegram.WebApp
      tg.ready()

      if (tg.platform === "ios" || tg.platform === "android") {
        this.isMobile = true
      } else {
        this.isMobile = false
      }
    }

    // Предотвращаем блокировку скролла
    this.$nextTick(() => {
      const contentScroll = this.$el?.querySelector(
        `.${this.$style.contentScroll}`
      )
      if (contentScroll) {
        // Убеждаемся, что скролл работает
        contentScroll.style.overflowY = "auto"
        contentScroll.style.webkitOverflowScrolling = "touch"
      }
    })
  },

  beforeUnmount() {
    // Сбрасываем состояние открытия фильтров в store
    this.$store.commit("setFiltersModalOpen", false)

    if (this.backBtn) {
      this.backBtn.offClick(this.startClose)
      this.backBtn.hide()
    }
  },

  methods: {
    startClose() {
      if (this.isClosing) return
      this.isClosing = true

      // Сбрасываем состояние открытия фильтров в store
      this.$store.commit("setFiltersModalOpen", false)

      if (this.backBtn) this.backBtn.hide()

      setTimeout(() => {
        this.$emit("close")
      }, 280)
    },

    reset() {
      this.localFilters = {
        brand: [],
        color: null,
        size: null,
        size_type: "EU",
        custom: null,
        category: [],
      }
    },

    apply() {
      const filtersToApply = { ...this.localFilters }

      // На фронте можно выбрать размер в любой системе,
      // но на сервер отправляем только EU размер.
      if (filtersToApply.size !== null && filtersToApply.size !== undefined) {
        const selectedType = String(
          filtersToApply.size_type || "EU"
        ).toUpperCase()
        const eu = convertSize(filtersToApply.size, selectedType, "EU")
        filtersToApply.size = eu !== null ? String(eu) : null
        filtersToApply.size_type = filtersToApply.size ? "EU" : null
      } else {
        filtersToApply.size_type = null
      }

      this.$emit("apply", filtersToApply)
      if (this.backBtn) this.backBtn.hide()
    },

    toggleBrand(b) {
      if (this.localFilters.brand.includes(b)) {
        this.localFilters.brand = this.localFilters.brand.filter((i) => i !== b)
      } else {
        this.localFilters.brand.push(b)
      }
    },

    selectAllBrands() {
      this.localFilters.brand = [...this.brands]
    },
    toggleCategory(value) {
      const arr = this.localFilters.category || []
      const idx = arr.indexOf(value)
      if (idx === -1) {
        this.localFilters.category = [...arr, value]
      } else {
        this.localFilters.category = arr.filter((v) => v !== value)
      }
    },
    openBrandsSection() {
      this.$emit("open-brands")
    },
    toggleColor(c) {
      // Если цвет уже выбран, отменяем выбор, иначе выбираем
      this.localFilters.color = this.localFilters.color === c ? null : c
    },
    toggleSize(size) {
      // Если размер уже выбран, отменяем выбор, иначе выбираем
      this.localFilters.size = this.isSameSize(this.localFilters.size, size)
        ? null
        : size
    },

    setSizeType(type) {
      const nextType = String(type || "EU").toUpperCase()
      const prevType = String(this.localFilters.size_type || "EU").toUpperCase()
      if (nextType === prevType) return

      // Пытаемся сохранить выбранный размер при переключении типа
      if (
        this.localFilters.size !== null &&
        this.localFilters.size !== undefined
      ) {
        const converted = convertSize(
          this.localFilters.size,
          prevType,
          nextType
        )
        this.localFilters.size = converted !== null ? converted : null
      }

      this.localFilters.size_type = nextType
    },

    parseNumeric(value) {
      const normalized = String(value ?? "")
        .trim()
        .replace(",", ".")
        .replace(/\s+/g, "")
      const num = Number(normalized)
      return Number.isFinite(num) ? num : null
    },

    isSameSize(a, b) {
      return String(a ?? "") === String(b ?? "")
    },

    formatSizeValue(value) {
      if (value === null || value === undefined) return ""
      return String(value).replace(".", ",")
    },
  },
}
</script>

<style lang="scss" module>
/* ===== BACKDROP ===== */
@keyframes fadeInBg {
  from {
    opacity: 0;
    backdrop-filter: blur(0px);
  }
  to {
    opacity: 1;
    backdrop-filter: blur(10px);
  }
}
@keyframes fadeOutBg {
  from {
    opacity: 1;
    backdrop-filter: blur(10px);
  }
  to {
    opacity: 0;
    backdrop-filter: blur(0px);
  }
}

.bg {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.12);
  backdrop-filter: blur(10px);
  z-index: 200;
  display: flex;
  justify-content: flex-end;
  animation: fadeInBg 0.28s ease forwards;
}

.bgClosing {
  animation: fadeOutBg 0.28s ease forwards !important;
}

/* ===== PANEL ===== */

@keyframes slideIn {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}
@keyframes slideOut {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(100%);
  }
}

.panel {
  width: 100%;
  height: 100%;
  background: #fff;
  padding: 4rem 0 0 0;
  transform: translateX(100%);
  animation: slideIn 0.28s ease forwards;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  touch-action: pan-y;
  &.indent {
    padding: 7rem 0 0 0;
  }
}

.contentScroll {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0 1rem;
  padding-bottom: 14rem;
  min-height: 0;
  -webkit-overflow-scrolling: touch;
  touch-action: pan-y;
  overscroll-behavior: contain;
  will-change: scroll-position;
}

.closing {
  animation: slideOut 0.28s ease forwards !important;
}

/* ===== SECTION ===== */

.section {
  margin-bottom: 1rem;
}

.sectionHeader {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.5rem;
}

.sectionTitle {
  font-size: 0.875rem;
  color: #777;
}

.sectionAction {
  display: flex;
  align-items: center;
  font-size: 0.875rem;
  color: #ec6608;
  background: none;
  border: none;
  svg {
    width: 0.625rem;
    height: 0.75rem;
    margin-left: 0.25rem;
  }
}

/* ===== BRAND LIST ===== */

.brandList {
  background: #f8f9fb;
  border-radius: 0.625rem;
  overflow: hidden;
}

.brandAllRow {
  position: relative;
  padding: 0.75rem 1rem;
}

.brandAllRow::after {
  content: "";
  position: absolute;
  left: 1rem;
  right: 0;
  bottom: 0;
  height: 1px;
  background: #dfe0e4;
}

.brandAllText {
  color: #ec6608;
  font-size: 1rem;
  font-weight: 400;
}

.brandRow {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 1rem;
  font-size: 1rem;
}

/* Псевдолиния под брендом */
.brandRow::after {
  content: "";
  position: absolute;
  left: 1rem; /* тот же отступ, что у текста */
  right: 0; /* тянется до правого края */
  bottom: 0;
  height: 1px;
  background: #dfe0e4;
}

.brandRow:last-child::after {
  display: none;
}

.circle {
  position: relative;
  width: 1.25rem;
  height: 1.25rem;
  border-radius: 50%;
  border: 1px solid #ccc;
  img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.activeCircle {
  background: #ec6608;
  border-color: #ec6608;
}

/* ===== COLORS ===== */

.colorRow {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.colorDot {
  width: 1.625rem;
  height: 1.625rem;
  border-radius: 50%;
  position: relative;
  border: 1px solid rgb(156, 156, 156);
}

.colorActive {
  border-color: #f07818;
}

.check {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 0.625rem;
  height: 0.625rem;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    height: 100%;
    filter: brightness(0) invert(1);
  }
}

.colorLight .check {
  img {
    filter: brightness(0);
  }
}

/* ===== SIZE ===== */

.sizeRow {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.sizeBtn {
  padding: 0.25rem 0.5rem;
  border-radius: 0.375rem;
  background: #f5f7fa;
  color: #000000;
  border: none;
  font-size: 0.875rem;
}

.activeSize {
  background: #ec6608;
  color: #fff;
}

/* SIZE (like Market/Product.vue) */
.sizeTabs {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #9b9b9b;
  position: relative;
}

.sizeTab {
  flex: 1;
  border: none;
  background: transparent;
  font-size: 0.875rem;
  padding: 0.5rem 0;
  text-align: center;
  color: #0a0a0a;
  cursor: pointer;
  position: relative;
  font-weight: 300;
}

.sizeTabActive {
  color: #0a0a0a;
  font-weight: 600;
}

.sizeTabActive::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: -1px;
  width: 100%;
  height: 2px;
  background: #0a0a0a;
  border-radius: 0.25rem;
}

.sizeScrollArea {
  display: flex;
  gap: 0.25rem;
  overflow-x: auto;
  padding: 0.5rem 0;
  scrollbar-width: none;
}

.sizeScrollArea::-webkit-scrollbar {
  display: none;
}

.sizeCell {
  border: none;
  background: transparent;
  font-size: 0.875rem;
  font-weight: 300;
  color: #0a0a0a;
  cursor: pointer;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  transition: background 0.2s, color 0.2s;
}

.sizeCellSelected {
  background: #f5f7fa;
  font-weight: 600;
}

/* ===== BOTTOM BAR ===== */

.bottomBar {
  position: fixed !important;
  bottom: 0 !important;
  left: 0 !important;
  right: 0 !important;
  width: auto !important;
  padding: 0.5rem 1rem !important;
  padding-bottom: calc(0.5rem + env(safe-area-inset-bottom)) !important;
  background: #ebeaea !important;
  display: flex !important;
  align-items: center;
  gap: 0.625rem;
  z-index: 10001 !important;
  visibility: visible !important;
  opacity: 1 !important;
  pointer-events: auto !important;
  &.indent {
    padding: 0.5rem 1rem 1rem 1rem !important;
    padding-bottom: calc(1rem + env(safe-area-inset-bottom)) !important;
  }
}

.clearBtn {
  flex: 1;
  min-height: 3.125rem;
  height: 3.125rem;
  border-radius: 0.625rem;
  background: #a41b1b0d;
  border: none;
  color: #ff3b30;
  font-size: 1rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
}

.applyBtn {
  flex: 1;
  min-height: 3.125rem;
  height: 3.125rem;
  border-radius: 0.625rem;
  background: #ec6608;
  border: none;
  color: #fff;
  font-size: 1rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
